import { createStore, compose as origCompose, combineReducers } from 'redux';
import { lazyReducerEnhancer } from 'pwa-helpers/lazy-reducer-enhancer.js';
import { connectRouter, navigate } from 'lit-redux-router';
import { DebugService } from './shared/services/debug.service.js';
import { REFI_ESIGN_CONST } from '../constants/app.constants.js';

const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || origCompose;
const router = window.refiRouter || createStore(state => state, compose(lazyReducerEnhancer(combineReducers)));
window.refiRouter = router;

class _Router {
  constructor() {
    connectRouter(router);
    this.debug = new DebugService('AppRouter');
    this.base = document.querySelector('base') ? document.querySelector('base').getAttribute('href') : '';
    this.rootElement = document.querySelector('refi-esign-app');
  }

  goTo(nav) {
    this.debug.log('goTo called with', nav);
    router.dispatch(navigate(`/#/esign/${nav}`));
    this.rootElement = document.querySelector('refi-esign-app');
    this.rootElement.dispatchEvent(REFI_ESIGN_CONST.ROUTE_CHANGE_EVENT);
  }

  sendStateChangedEvent() {
    this.debug.log('Sending state-changed event to host app');
    const ev = new CustomEvent('host-app-event', {
      bubbles: true,
      composed: true,
      detail: {
        actionName: 'state-changed',
        from: 'esign-mfe',
        data: {
          state: 'e-sign',
        },
      },
    });
    this.rootElement.dispatchEvent(ev);
  }

  sendNextMFEEvent() {
    this.debug.log('Sending next-mfe event to host app');
    const ev = new CustomEvent('host-app-event', {
      bubbles: true,
      composed: true,
      detail: {
        actionName: 'next-mfe',
        data: {},
      },
    });
    this.rootElement.dispatchEvent(ev);
  }
}

export const Router = new _Router();
